import React from 'react';

export const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8125 3.5H2.1875M5.6875 6.125V9.625M8.3125 6.125V9.625M10.9375 3.5V11.375C10.9375 11.6166 10.8416 11.8483 10.6699 12.0199C10.4983 12.1916 10.2666 12.2875 10.025 12.2875H3.975C3.7334 12.2875 3.50172 12.1916 3.33012 12.0199C3.15853 11.8483 3.0625 11.6166 3.0625 11.375V3.5M9.1875 3.5V2.625C9.1875 2.3834 9.09147 2.15172 8.91988 1.98012C8.74828 1.80853 8.5166 1.7125 8.275 1.7125H5.725C5.4834 1.7125 5.25172 1.80853 5.08012 1.98012C4.90853 2.15172 4.8125 2.3834 4.8125 2.625V3.5"
      stroke="#FF3838"
      strokeWidth="1.3125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
